<template>
    <b-modal
        v-model="show"
        :title="$t('finance2.universalBank.paymentTransaction.add.title')"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        size="xl"
    >
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="operationType">Тип проводки: <span class="red">*</span></label>
                                        <select name="operationType" id="operationType"
                                                class="form-control"
                                                v-model="payment.operationType"
                                        >
                                            <option value="1">Обычная проводка</option>
                                            <option value="2">Казначейский платеж</option>
                                        </select>
                                        <div v-if="$v.payment.operationType.$error" class="red">Тип проводки</div>
                                    </div>
                                    <div class="form-group">
                                        <label>Код платежа: <span class="red">*</span></label>
                                        <v-select v-model="payment.paymentCode" label="text"
                                                  :options="paymentCodes"
                                                  :filterable="false"
                                                  @search="onPaymentCodeSearch"
                                                  @search:focus="onPaymentCodeFocus"
                                        >
                                            <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.text"></div>
                                            </template>
                                            <template slot="selected-option"
                                                      v-if="payment && payment.paymentCode && payment.paymentCode.text">
                                                <div v-html="payment.paymentCode.text"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                        <div v-if="$v.payment.paymentCode.id.$error" class="red">Код платежа</div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="card card-body">
                                        <div class="debit-wrap">
                                            <span>Дебет</span>
                                        </div>
                                        <div class="form-group">
                                            <label for="debitName">Дебет ташкилот номи</label>
                                            <input type="text"
                                                   id="debitName"
                                                   class="form-control"
                                                   v-model="payment.debitName"
                                                   :disabled="true"
                                            >
                                        </div>
                                        <div class="form-group">
                                            <label for="debitInn">Дебет ИНН</label>
                                            <input type="text"
                                                   id="debitInn"
                                                   class="form-control"
                                                   v-model="payment.debitInn"
                                                   :disabled="true"
                                            >
                                        </div>
                                        <div class="form-group">
                                            <label for="debitBranch">Дебет МФО</label>
                                            <input type="text"
                                                   id="debitBranch"
                                                   class="form-control"
                                                   v-model="payment.debitBranch"
                                                   :disabled="true"
                                            >
                                        </div>
                                        <div class="form-group">
                                            <label for="debitAccount">Дебет хисоб ракам</label>
                                            <input type="text"
                                                   id="debitAccount"
                                                   class="form-control"
                                                   v-model="payment.debitAccount"
                                                   :disabled="true"
                                            >
                                        </div>
                                        <div class="section-header text-center">
                                            <span class="text-wrap">Тулов сумма ва максади</span>
                                        </div>
                                        <div class="form-group">
                                            <label>Тулов суммаси <span class="red">*</span></label>
                                            <numeric-input :precision="2" v-model="payment.amount" :maxlength="8" :class="{invalid: $v.payment.amount.$error}"></numeric-input>
                                            <div v-if="$v.payment.amount.$error" class="red">Тулов суммаси</div>
                                        </div>
                                        <div class="form-group">
                                            <label for="purpose">Тулов максади <span class="red">*</span></label>
                                            <textarea id="purpose" class="form-control"
                                                      cols="30" rows="3"
                                                      v-model="payment.purposeName"
                                                      :class="{invalid: $v.payment.purposeName.$error}"
                                            ></textarea>
                                            <div v-if="$v.payment.purposeName.$error" class="red">Тулов максади</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="card card-body">
                                        <div class="debit-wrap">
                                            <span>Кредит</span>
                                        </div>
                                        <div class="form-group">
                                            <label for="recipientName">Кредит ташкилот номи <span class="red">*</span></label>
                                            <input type="text"
                                                   id="recipientName"
                                                   class="form-control"
                                                   v-model="payment.recipientName"
                                                   :class="{invalid: $v.payment.recipientName.$error}"
                                            >
                                            <div v-if="$v.payment.recipientName.$error" class="red">Кредит ташкилот номини киритинг</div>
                                        </div>
                                        <div class="form-group">
                                            <label>Кредит ИНН <span class="red">*</span></label>
                                            <the-mask class="form-control"
                                                      type="text"
                                                      v-model="payment.recipientInn"
                                                      :mask="'#########'"
                                            ></the-mask>
                                            <div v-if="!$v.payment.recipientInn.required" class="red">Кредит ИНН</div>
                                            <div v-if="!$v.payment.recipientInn.minLength" class="red">Узунлиги 9 тадан кам булмаслиги керак</div>
                                        </div>
                                        <div class="form-group">
                                            <label>Кредит МФО <span class="red">*</span></label>
                                            <the-mask class="form-control"
                                                      type="text"
                                                      v-model="payment.recipientBranch"
                                                      :mask="'#####'"
                                            ></the-mask>
                                            <div v-if="!$v.payment.recipientBranch.required" class="red">Кредит МФО</div>
                                            <div v-if="!$v.payment.recipientBranch.minLength" class="red">Узунлиги 5 тадан кам булмаслиги керак</div>
                                        </div>
                                        <div class="form-group">
                                            <template v-if="payment.operationType == 1">
                                                <label>Кредит хисоб ракам(ХР) <span class="red">*</span></label>
                                                <the-mask class="form-control"
                                                          type="text"
                                                          v-model="payment.recipientAccount"
                                                          :mask="'####################'"
                                                ></the-mask>
                                                <div v-if="!$v.payment.recipientAccount.minLength" class="red">Узунлиги 20 тадан кам булмаслиги керак</div>
                                            </template>
                                            <template v-else-if="payment.operationType == 2">
                                                <label>Кредит хисоб ракам(Счет Казначейства) <span class="red">*</span></label>
                                                <the-mask class="form-control"
                                                          type="text"
                                                          v-model="payment.recipientAccount"
                                                          :mask="['#########################','###########################']"
                                                ></the-mask>
                                                <div v-if="!$v.payment.recipientAccount.minLength" class="red">Узунлиги 25-27 тадан кам булмаслиги керак</div>
                                            </template>
                                            <div v-if="!$v.payment.recipientAccount.required" class="red">Кредит хисоб ракам</div>
                                        </div>
                                    </div>
                                </div>
                                <!--
                                    DRAFT -3 // - коралама
                                    WAIT - 4 // - кутилябди
                                    DONE - 5 // бажарилган
                                -->
                                <div class="col-12" v-if="payment.state == state.DRAFT || payment.state == state.UNKNOWN">
                                    <div class="text-center">
                                        <button class="all-btn mr-3" @click="save(state.DRAFT)"
                                                v-if="hasPermission('UNIVERSAL_BANK_PAYMENT_TRANSACTION_ADD')"
                                                :disabled="processing">Коралама</button>

                                        <button class="all-btn add-btn" @click="save(state.DONE)"
                                                v-if="hasPermission('UNIVERSAL_BANK_PAYMENT_TRANSACTION_EDIT')"
                                                :disabled="processing">Тулаш</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BankApiLoginInputView @input="onChangeLoginForm" :smsField="true"></BankApiLoginInputView>
            </div>
        </div>
        <template #modal-footer>
            <div class="w-100">
                <button
                        class="all-btn delete-btn float-right mr-2"
                        @click="show=false"
                >
                    {{$t('finance2.universalBank.transaction.payment.action.balanceViewClose')}}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import {TheMask} from 'vue-the-mask';
    import {required,minValue,minLength} from 'vuelidate/lib/validators';
    import BankApiLoginInputView from "@/views/common/BankApiLoginInputView";
    import {STATE} from '@/shared/constants/universalBankState'
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate} from '@/shared/utils';

    export default {
        name: "UniversalBankPaymentTransactionEditModal",
        components: {
            BankApiLoginInputView,
            'b-modal': bModal,
            TheMask
        },
        directives: {
            'b-modal': bModalDirective,
            BankApiLoginInputView
        },
        data() {
            return {
                parseDate: parseDate,
                formatDate: formatDate,
                show: false,
                processing: false,
                paymentCodeFilter: initFilterModel(),
                payment: {
                    id: null,
                    debitName: '"ELEKTRON BAHOLASH" МЧЖ',
                    debitBranch: '00996',
                    debitAccount: '20208000300424417003',
                    debitInn: '',
                    recipientInn: '',
                    amount: 0,
                    recipientBranch: '',
                    recipientAccount: '',
                    recipientName: '',
                    purposeCode: '',
                    purposeName: '',
                    state: 3,
                    docNumber: '',
                    fixedExpenseId: null,
                    expensePayDate: null,
                    finishedDate: null,
                    operationType: 1,
                    login: {},
                    paymentCode: null
                },
                state: STATE,
                paymentCodes: []
            }
        },
        validations() {
            return {
                payment: {
                    operationType: {
                        required
                    },
                    paymentCode: {
                        id: {
                            required: required
                        }
                    },
                    debitName: {
                        required
                    },
                    debitBranch: {
                        required
                    },
                    debitAccount: {
                        required
                    },
                    amount: {
                        required,
                        minValue: minValue(1)
                    },
                    purposeName: {
                        required
                    },
                    recipientName: {
                        required
                    },
                    recipientInn: {
                        required,
                        minLength: minLength(9)
                    },
                    recipientBranch: {
                        required,
                        minLength: minLength(5)
                    },
                    recipientAccount: {
                        required,
                        minLength: minLength(20)
                    }
                }
            }
        },
        methods: {
            save(state) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                if (state == this.state.DONE) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('messages.common.reallyWant', {0: this.$t('finance.ipoteka.paymentTransaction.confirmMsg')}),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#dd3333',
                        confirmButtonText: 'Тулаш',
                        cancelButtonText: 'Бекор қилиш'
                    }).then((result) => {
                        if (result.value) {
                            // this.$eventBus.$emit('showBankApiLoginInputView', null);
                            this.createPayment(this.state.DONE)
                        }
                    });
                } else {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('messages.common.reallyWant', {0: this.$t('finance.ipoteka.paymentTransaction.draftMsg')}),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#4321dd',
                        confirmButtonText: 'Черновик',
                        cancelButtonText: 'Бекор қилиш'
                    }).then((result) => {
                        if (result.value) {
                            this.createPayment(state);
                        }
                    });
                }
            },
            createPayment(state) {
                console.log(state);
                console.log(this.payment);

                this.processing = true;
                this.payment.state = state;
                this.$http.post('/admin/accountant/universal-bank-payment/save', this.payment)
                    .then(res => {
                        console.log(res);
                        this.processing = false;
                    }, err =>{
                        console.log(err);
                        this.processing = false;
                    });
            },
            onChangeLoginForm(data) {
                console.log(data);
                if (data) {
                    this.payment.login = {
                        login: data.login,
                        password: data.password,
                        smsCode: data.smsCode
                    };
                    this.createPayment(this.state.DONE)
                } else {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: 'Login or password is empty',
                        type: 'error'
                    });
                }
            },
            onPaymentCodeSearch(searchTxt, loading) {
                loading(true);
                this.paymentCodes = [];
                this.paymentCodeFilter.search = searchTxt;
                this.$http.post('payment-code/search', this.paymentCodeFilter)
                    .then(res => {
                        this.paymentCodes = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onPaymentCodeFocus() {
                this.paymentCodes = [];
                this.paymentCodeFilter.search = '';
                this.$http.post('payment-code/search', this.paymentCodeFilter)
                    .then(res => {
                        this.paymentCodes = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('showUniversalBankPaymentTransactionEdit', (data) => {
                console.log(data);
                if (data) {
                    this.payment.id = data.id;
                    this.payment.state = data.state;
                    this.payment.recipientInn = data.recipientInn;
                    this.payment.amount = data.amount;
                    this.payment.recipientBranch = data.recipientBranch;
                    this.payment.recipientAccount = data.recipientAccount;
                    this.payment.recipientName = data.recipientName;
                    this.payment.purposeCode = data.purposeCode;
                    this.payment.purposeName = data.purposeName;
                    this.payment.paymentCode = data.paymentCode;
                    this.payment.operationType = data.operationType;

                    if (data.fixedExpenseId) {
                        this.payment.fixedExpenseId = data.fixedExpenseId
                    }

                    if (data.expensePayDate) {
                        this.payment.expensePayDate = parseDate(data.expensePayDate)
                    }
                }
                this.show = true
            })
        }
    }
</script>

<style scoped>
    .debit-wrap {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid gray;
        margin-bottom: 25px;
    }

    .text-wrap {
        font-size: 16px;
        text-transform: uppercase;
        font-weight: bold;
    }

    textarea {
        font-size: 16px;
    }
    .card {
        border-radius: 0;
    }
</style>